import { SidebarInset, SidebarProvider, SidebarTrigger } from "@amazing-care/ui/sidebar";
import { Suspense } from "react";
import { AnimatedOutlet } from "@/components/animated-outlet";
import { PageSkeleton } from "@/components/page-skeleton";
import { ThemeToggle } from "@/components/theme-toggle";
import { StaffBreadcrumbs } from "@/features/navigation/staff-breadcrumbs";
import { StaffSidebar } from "@/features/navigation/staff-sidebar";
import { GlobalSearch } from "@/features/search/global-search";
import { usePreloadPages } from "@/hooks/use-preload-pages";

export function StaffLayout() {
  usePreloadPages();

  return (
    <SidebarProvider>
      <StaffSidebar />
      <SidebarInset>
        <header className="sticky top-0 z-40 flex h-14 items-center gap-2 border-b bg-background/80 px-4 backdrop-blur supports-backdrop-filter:bg-background/60">
          <SidebarTrigger />
          {/* On a phone the page title already says where you are, and the trail
              would push search and the theme toggle off the screen. */}
          <div className="hidden min-w-0 sm:block">
            <StaffBreadcrumbs />
          </div>
          <div className="flex-1" />
          <GlobalSearch />
          <ThemeToggle />
        </header>
        <main className="flex-1 px-4 py-8 sm:px-6 lg:px-8">
          <Suspense fallback={<PageSkeleton />}>
            <AnimatedOutlet />
          </Suspense>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
